"use client"
import { pwaTeamWidgetsPath} from "@/utils/urlHelper";
import Link from "next/link";
import CodeIcon from "@/assets/icon/code.svg";
import { useAbility } from "@/app/pwa/lib/ability-context";
import {subject} from "@casl/ability";

export function TeamWidgetTeaser({type, teamId} : {type: "table"|"gameday"|"schedule"|"upcoming"|"squad", teamId:number|string}) {
  const  ability = useAbility()
  if(ability.cannot("list", subject("TeamWidget", {teamId: teamId.toString()}))) {
    return <></>
  }

  const types = {
    table: {title: "Tabellen-Widget", anchor: "tabelle"},
    gameday: {title: "Spieltag-Widget", anchor: "spieltag"},
    schedule: {title: "Spielplan-Widget", anchor: "spielplan"},
    upcoming: {title: "Nächste Spiele-Widget", anchor: "naechste-spiele"},
    squad: {title: "Kader-Widget", anchor: "kader"}
  }


  return <>
    {/* TODO:Emanuel! Show only to admins or whoever since this is to no interested for most people */}
    <div className="mt-section">
      <Link className="text-sm text-gray-200 hover:underline hover:text-gray-900 transition duration-fast" href={`${pwaTeamWidgetsPath(teamId.toString())}#${types[type].anchor}`}><CodeIcon className="h-3 w-3 inline-block align-baseline relative top-px" /> {types[type].title} in deiner Webseite einbetten</Link>
    </div>
  </>
}
